<template>
    <div v-if="item">
        <div class="log-item" v-if="!isMobile" :style="item?.available?'':'filter: grayscale(100%)'">
            <div class="item-name">
                <img :src="item.iconUrl" />
                <div class="name">{{item.name}}</div>
                <div class="item-tags">
                    <div class="tag1" v-if="item.freeInsure">{{ $t('setup556') }}</div>
                    <div class="tag" v-if="item.taxInclude">{{ $t('setup557') }}</div>
                </div>
            </div>
            <div class="item-info">
                <div class="info-title">{{ $t('setup558') }}</div>
                <div class="info-price">
                    {{ estimationRate(item?.feeDetail?.total||0, userStore.exchangeRate.symbol,
                        userStore.exchangeRate.rate)
                        }}</div>
                <div>
                    {{ $t('setup559') }}
                   </div>
                <div class="info-title">{{ $t('setup560') }}</div>
                <div class="info-day">{{item.transitTime}}<span>{{ $t('setup561') }}</span></div>
            </div>
            <div class="item-desc">
                {{item.features}}
            </div>
            <div class="item-btns">
                <div class="detail-btn" @click="toDetail">{{$t('number88')}}</div>
            </div>
        </div>
        <div class="logphone-item" v-else :style="item?.available?'':'filter: grayscale(100%)'">
            <div class="item-top">
                <img :src="item.iconUrl" />
                <div class="top-r">
                    <div class="name" >{{item.name}}</div>
                    <div class="item-tags">
                        <div class="tag1" v-if="item.freeInsure">{{ $t('setup556') }}</div>
                        <div class="tag" v-if="item.taxInclude">{{ $t('setup557') }}</div>
                    </div>
                </div>

            </div>
            <div class="item-center">
                <div>
                    <div>{{ $t('setup558') }}</div>
                    <div style="color: #FC3938;">  {{ estimationRate(item?.feeDetail?.total||0, userStore.exchangeRate.symbol,
                        userStore.exchangeRate.rate)
                        }}</div>
                </div>
                <div>
                    <div>{{ $t('setup560') }}</div>
                    <div>{{item.transitTime}}<span>{{ $t('setup561') }}</span></div>
                </div>
            </div>
            <div class="btn" @click="toDetail">{{$t('number88')}}</div>
        </div>
     
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import Detail from '../detail.vue';

import { estimationRate } from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
import { useRouter } from 'vue-router'
const props = defineProps(['item']);
const emits = defineEmits(['show'])
const userStore = useUserStore()

const router = useRouter()
const contentRef = ref(null);
const isShow = ref(false);
const isExpanded = ref(false);
const contentHeight = ref(0);

const contentStyle = computed(() => {
    if (contentHeight.value < 300) {
        return {
            overflow: 'hidden',
            height: isExpanded.value ? `${contentHeight.value}px` : 'auto',
            transition: 'height 0.3s ease',
        };
    } else {
        return {
            overflow: 'hidden',
            height: isExpanded.value ? `${contentHeight.value}px` : '300px',
            transition: 'height 0.3s ease',
        };
    }
});

const showMoreButton = computed(() => {
    return contentHeight.value > 300;
});

const toDetail = () => {
    console.log('props',props.item)
    if(props.item.available){
        localStorage.setItem('estimationOne',JSON.stringify(props.item));

        if(isMobile.value){
            emits('show')
        }else{
            router.push('/estimation/detail/1')
        }
       
    }
  
};


const isMobile = ref(false);
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

})
</script>

<style scoped lang='scss'>
.log-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F1F3F5;
    height: 227px;
    padding: 35px 0;
    box-sizing: border-box;

    // filter: grayscale(60%);
    .item-name,
    .item-btns {
        height: 150px;
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        >img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            object-fit: cover;
        }

        .item-tags {
            display: flex;
            justify-content: center;
            align-items: center;

            >div {
                padding: 0 13px;
                height: 24px;
                background: #E5FFF4;
                border-radius: 12px;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #148A55;
                line-height: 24px;
                font-style: normal;
            }

            .tag1 {
                background: #FFF1EB;
                color: #FF9845;
                margin-right: 8px;
            }
        }

        .name {
            width: 100%;
            font-family: MicrosoftYaHei;
            font-size: 18px;
            color: #333333;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
            padding: 10px;
        }

        .detail-btn {
            width: 110px;
            height: 36px;
            background: #FC3938;
            border-radius: 28px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 36px;
            text-align: center;
            font-style: normal;
        }
    }

    .item-desc,
    .item-info {
        width: 28%;
        font-family: MicrosoftYaHei;
        font-size: 10px;
        color: #888888;
        line-height: 15px;
        text-align: left;
        font-style: normal;
        height: 150px;

    }

    .item-desc {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 10; //显示的行
    }

    .item-info {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #888888;
        line-height: 12px;
        text-align: left;
        font-style: normal;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-title {
            font-size: 14px;
            color: #888888;
            line-height: 19px;
        }

        .info-price,
        .info-day {
            font-weight: bold;
            font-size: 22px;
            color: #FC3938;
            line-height: 22px;
        }

        .info-day {
            color: #333333;

            >span {
                font-size: 12px;
            }
        }
    }
}

.logphone-item {
    background-color: #fff;
    margin-top: 5px;
    margin-bottom: 10px;
    height: 245px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 6px rgba(237, 237, 237, 0.75);
    border-radius: 8px;
    padding: 20px 15px;
    box-sizing: border-box;

    .item-top {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #F1F1F1;
        padding-bottom: 20px;
        height: 80px;

        >img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 10px;
        }

        .top-r {
            width: calc(100% - 70px);
            .item-tags {
                display: flex;
                align-items: center;

                >div {
                    padding: 0 13px;
                    height: 24px;
                    background: #E5FFF4;
                    border-radius: 12px;
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: #148A55;
                    line-height: 24px;
                    font-style: normal;
                }

                >div:first-child {
                    background: #FFF1EB;
                    color: #FF9845;
                    margin-right: 8px;
                }
            }

            .name {
                width: 100%;
                font-family: MicrosoftYaHei;
                font-size: 18px;
                color: #333333;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap; //溢出不换行
                padding-bottom: 10px;
            }

        }
    }
    .item-center{
        height: 93px;
        display: flex;
        align-items: center;
        >div{
            width: 50%;
            >div:first-child{
                font-size: 14px;
                color: #888888;
                line-height: 19px;
                text-align: center;
                font-style: normal;
            }
            >div:last-child{
                font-weight: bold;
                font-size: 22px;
                color: #333333;
                line-height: 18px;
                text-align: center;
                font-style: normal;
                margin-top: 15px;
                >span{
                    font-size: 18px;
                }
            }
        }
    }
    .btn{
        width: 100%;
        height: 32px;
        background: #FEF1EA;
        border-radius: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FF4F00;
        line-height: 32px;
        text-align: center;
        font-style: normal;
    }
}
</style>